import { createAction } from 'redux-actions';
import { create } from 'lodash';
import { plugin } from '../../constants/index';

export const INIT_PLUGIN_COMMS_CENTER = 'PLUGIN_INIT_' + plugin.CHEDRI_COMMS_CENTER;

export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_CONNECT_CANCEL = 'SOCKET_CONNECT_CANCEL';
export const SOCKET_CONNECT_SUCCESS = 'SOCKET_CONNECT_SUCCESS';
export const SOCKET_CONNECT_FAILURE = 'SOCKET_CONNECT_FAILURE';
export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
export const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED';
export const SOCKET_EMIT = 'SOCKET_EMIT';
export const SOCKET_EVENT = 'SOCKET_EVENT';
export const SOCKET_REGISTER_CALLBACK = 'SOCKET_REGISTER_CALLBACK';
export const SOCKET_RESET_CALLBACK = 'SOCKET_RESET_CALLBACK';

export const SOCKET_CONNECT_ANONYMOUS = 'SOCKET_CONNECT_ANONYMOUS';
export const SOCKET_CONNECT_AUTH_CUSTOMER = 'SOCKET_CONNECT_AUTH_CUSTOMER';

export const SET_AGENT_STATUS = 'COMMUNICATION_SET_AGENT_STATUS';
export const NEW_CUSTOMER = 'COMMUNICATION_NEW_CUSTOMER';
export const NEW_CUSTOMER_ACCEPT = 'COMMUNICATION_NEW_CUSTOMER_ACCEPT';
export const MOBILE_DISCONNECTED = 'MOBILE_DISCONNECTED';
export const SET_CUSTOMER_CHAT = 'COMMUNICATION_SET_CUSTOMER_CHAT';
export const REQUEST_CONTACT = 'COMMUNICATION_REQUEST_CONTACT';
export const REQUEST_CONTACT_SUCCESS = 'COMMUNICATION_REQUEST_CONTACT_SUCCESS';
export const REQUEST_CONTACT_FAILURE = 'COMMUNICATION_REQUEST_CONTACT_FAILURE';
export const REQUEST_CONTACT_RESET = 'COMMUNICATION_REQUEST_CONTACT_RESET';
export const INITIATE_REVIEW = 'COMMUNICATION_INITIATE_REVIEW';
export const FINISH_REVIEW = 'COMMUNICATION_FINISH_REVIEW';
export const SEND_REVIEW = 'COMMUNICATION_SEND_REVIEW';
export const SEND_REVIEW_SUCCESS = 'COMMUNICATION_SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_FAILURE = 'COMMUNICATION_SEND_REVIEW_FAILURE';

export const setAgentStatus = createAction(SET_AGENT_STATUS);
export const newCustomer = createAction(NEW_CUSTOMER);
export const acceptNewCustomer = createAction(NEW_CUSTOMER_ACCEPT);
export const setCustomerChat = createAction(SET_CUSTOMER_CHAT);

/* Socket actions */

export const socketConnect = createAction(SOCKET_CONNECT);
export const socketConnectCancel = createAction(SOCKET_CONNECT_CANCEL);
export const socketConnectSuccess = createAction(SOCKET_CONNECT_SUCCESS, (token, expires, anonymous) => ({
  token,
  expires,
  anonymous,
}));
export const socketConnectFailure = createAction(SOCKET_CONNECT_FAILURE, err => err);
export const socketConnected = createAction(SOCKET_CONNECTED);
export const socketDisconnect = createAction(SOCKET_DISCONNECT);
export const socketDisconnected = createAction(SOCKET_DISCONNECTED);
export const socketEmit = createAction(SOCKET_EMIT, (eventName, args, callback) => ({ eventName, args, callback }));
export const socketEvent = createAction(SOCKET_EVENT, ({ eventName, args }) => ({
  eventName,
  args,
}));
export const socketRegisterCallback = createAction(SOCKET_REGISTER_CALLBACK);
export const socketResetCallback = createAction(SOCKET_RESET_CALLBACK);

export const socketConnectAnonymous = createAction(SOCKET_CONNECT_ANONYMOUS, ({ type, agent, email, name }) => ({
  type,
  agent,
  email,
  name,
}));

export const socketConnectAuthCustomer = createAction(SOCKET_CONNECT_AUTH_CUSTOMER);

/* Communication actions */

export const sendUsersList = createAction(SOCKET_EMIT, users => ({
  eventName: 'users_list',
  args: users,
}));

export const enableAgent = createAction(
  SOCKET_EMIT,
  ({ isAudioCallAvailable = false, isVideoCallAvailable = false }) => ({
    eventName: 'activate_agent',
    args: { isAudioCallAvailable, isVideoCallAvailable },
  })
);

export const disableAgent = createAction(SOCKET_EMIT, () => ({
  eventName: 'deactivate_agent',
}));

export const sendViewerSettings = createAction(
  SOCKET_EMIT,
  ({
    to,
    clientId,
    region,
    accessKeyId,
    secretAccessKey,
    sessionToken,
    channelARN,
    channelEndpoints,
    iceServers,
    customerVideoCall,
  }) => ({
    eventName: 'send_viewer_settings',
    args: {
      to,
      clientId,
      region,
      accessKeyId,
      secretAccessKey,
      sessionToken,
      channelARN,
      channelEndpoints,
      iceServers,
      customerVideoCall,
    },
  })
);

/*
42/chatter,["videocall_ring",{"from":"ChedriAdmin","fromName":"Michal Sobczak","to":"christiandein","toName":"Christian Dein","role":"employee"}]
42/chatter,["send_viewer_settings",{"to":"christiandein","region":"eu-central-1","accessKeyId":"ASIA4CBAIR6FKL4S5NNX","secretAccessKey":"r/cdpK05UUX/5SJuCXGjJzFHEES8GLgKutDtpaOo","sessionToken":"FwoGZXIvYXdzED8aDF9RCBPyQ+Wx5d3DkiJq9svLrsFkAS3fNDrXGuPcO320D+CMG+Cx/PlDn2w7Fn7+3CBRck6u2hM/yMLNaonnOCOSazQc8h3FSj0uFZNm4yYLcxlfbTIS4VTWgei1w3WjlM/y9JeWckSQTO+LgiXuljF4TrER4GA1ByjszoT1BTIoBl+6SpTjUaCPSx39ZrO3pnVJr5qNJTwxqS6PLtg+IJzx0yw9movRqg==","channelARN":"arn:aws:kinesisvideo:eu-central-1:828996358026:channel/chedri_1/1585147155597","channelEndpoints":{"WSS":["wss://v-1c208c78.kinesisvideo.eu-central-1.amazonaws.com"],"HTTPS":["https://r-19ddd6ea.kinesisvideo.eu-central-1.amazonaws.com"]},"iceServers":[{"Uris":["turn:52.29.109.242:443"],"Username":"1587619993:djE6YXJuOmF3czpraW5lc2lzdmlkZW86ZXUtY2VudHJhbC0xOjgyODk5NjM1ODAyNjpjaGFubmVsL2NoZWRyaV8xLzE1ODUxNDcxNTU1OTc=","Password":"ZnMUfGffs8bHAPl7jxGySPEtCRNGj4wd0r0+N9Ul0Ds=","Ttl":300},{"Uris":["turn:3.126.153.3:443"],"Username":"1587619993:djE6YXJuOmF3czpraW5lc2lzdmlkZW86ZXUtY2VudHJhbC0xOjgyODk5NjM1ODAyNjpjaGFubmVsL2NoZWRyaV8xLzE1ODUxNDcxNTU1OTc=","Password":"dZYc0vQ84nVuSY95OafAkYeYXLeBGh69QzCROFs0iCs=","Ttl":300}]}]
42/chatter,["videocall_accepted",{"from":"ChedriAdmin","fromName":"Michal Sobczak","to":"christiandein","toName":"Christian Dein","role":"employee"}]
42/chatter,["videocall_rejected",{"from":"ChedriAdmin","fromName":"Michal Sobczak","to":"christiandein","toName":"Christian Dein","role":"employee"}]
42/chatter,["videocall_ended",{"from":"ChedriAdmin","fromName":"Michal Sobczak","to":"christiandein","toName":"Christian Dein","role":"employee"}]
*/

export const sendCallRing = createAction(
  SOCKET_EMIT,
  (video, { from, fromName, to, toName, role, customerVideoCall, customerChat }) => ({
    eventName: (video ? 'video' : '') + 'call_ring',
    args: { from, fromName, to, toName, role, customerVideoCall, customerChat },
  })
);

export const sendAcceptCall = createAction(SOCKET_EMIT, (video, { from, fromName, to, toName, role }) => ({
  eventName: (video ? 'video' : '') + 'call_accepted',
  args: { from, fromName, to, toName, role },
}));

export const sendRejectCall = createAction(SOCKET_EMIT, (video, { from, fromName, to, toName, role }) => ({
  eventName: (video ? 'video' : '') + 'call_rejected',
  args: { from, fromName, to, toName, role },
}));

export const sendCancelCall = createAction(SOCKET_EMIT, (video, { from, fromName, to, toName, role }) => ({
  eventName: (video ? 'video' : '') + 'call_cancelled',
  args: { from, fromName, to, toName, role },
}));

export const sendEndCall = createAction(SOCKET_EMIT, (video, { from, fromName, to, toName, role }) => ({
  eventName: (video ? 'video' : '') + 'call_ended',
  args: { from, fromName, to, toName, role },
}));

export const sendChangeCameraFacingMode = createAction(SOCKET_EMIT, ({ to, from, facingMode }) => ({
  eventName: 'change_camera_facing_mode',
  args: { to, from, facingMode },
}));

export const sendMicrophoneMuted = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'microphone_muted',
  args: { to, from },
}));

export const sendMicrophoneUnmuted = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'microphone_unmuted',
  args: { to, from },
}));

export const sendCameraActivated = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'camera_activated',
  args: { to, from },
}));

export const sendCameraDeactivated = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'camera_deactivated',
  args: { to, from },
}));

export const sendDesktopSharingActivated = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'desktop_sharing_activated',
  args: { to, from },
}));

export const sendDesktopSharingDeactivated = createAction(SOCKET_EMIT, ({ to, from }) => ({
  eventName: 'desktop_sharing_deactivated',
  args: { to, from },
}));

export const mobileDisconnected = createAction(SOCKET_EMIT, () => ({ eventName: 'mobile_user_disconnected' }));

export const requestContact = createAction(REQUEST_CONTACT, ({ name, email, content }) => ({ name, email, content }));
export const requestContactSuccess = createAction(REQUEST_CONTACT_SUCCESS, data => ({ data }));
export const requestContactFailed = createAction(REQUEST_CONTACT_FAILURE, error => ({ error }));
export const requestContactReset = createAction(REQUEST_CONTACT_RESET);

export const initiateReview = createAction(
  INITIATE_REVIEW,
  ({ agent, conversation, customerChatId, customerVideoCallId }) => ({
    agent,
    conversation,
    customerChatId,
    customerVideoCallId,
  })
);
export const finishReview = createAction(FINISH_REVIEW);

export const sendReview = createAction(SEND_REVIEW, ({ overallStars, connectionQualityStars, remarks }) => ({
  overallStars,
  connectionQualityStars,
  remarks,
}));
export const sendReviewSuccess = createAction(SEND_REVIEW_SUCCESS);
export const sendReviewFailure = createAction(SEND_REVIEW_FAILURE, error => ({ error }));

export default {
  /* Socket actions */
  socketConnect,
  socketConnectFailure,
  socketConnected,
  socketDisconnect,
  socketDisconnected,
  socketEmit,
  socketEvent,
  socketRegisterCallback,
  socketResetCallback,
  socketConnectAnonymous,
  /* Communication actions */
  sendUsersList,
  enableAgent,
  disableAgent,
  sendViewerSettings,
  sendAcceptCall,
  sendRejectCall,
  sendCancelCall,
  sendEndCall,
  sendChangeCameraFacingMode,
  sendMicrophoneMuted,
  sendMicrophoneUnmuted,
  sendCameraActivated,
  sendCameraDeactivated,
  sendDesktopSharingActivated,
  sendDesktopSharingDeactivated,
  mobileDisconnected,
  setCustomerChat,
  requestContact,
  requestContactSuccess,
  requestContactFailed,
  requestContactReset,
  socketConnectAuthCustomer,
  initiateReview,
  finishReview,
  sendReview,
  sendReviewSuccess,
  sendReviewFailure,
};
